"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16LocationPinDisabledLine = function Svg16LocationPinDisabledLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.707 3.293a1 1 0 0 0-1.414 1.414L6.43 7.844l1.62 1.62 5.916 5.916 1.443 1.443 3.884 3.884a1 1 0 0 0 1.414-1.414l-4.223-4.224c.79-1.442 1.516-3.218 1.516-4.95C18 6.796 15.369 4 12 4a5.914 5.914 0 0 0-4.506 2.08L4.707 3.293zm8.136 13.671l1.425 1.426-.074.094a24.829 24.829 0 0 1-.7.845 2 2 0 0 1-2.989 0c-.24-.275-.473-.558-.7-.845-.402-.51-.942-1.23-1.485-2.071C7.306 14.843 6 12.443 6 10.12l2.603 2.604c.563 1.365 1.42 2.693 2.133 3.675C11.438 17.368 12 18 12 18s.35-.394.843-1.036zm-2.52-8.055L8.913 7.5A3.948 3.948 0 0 1 12 6c2.21 0 4 1.844 4 4.12 0 1.101-.425 2.322-.998 3.468l-1.911-1.911a2 2 0 1 0-2.767-2.767z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16LocationPinDisabledLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16LocationPinDisabledLine;
exports.default = _default;